import React, { useEffect, useState, createContext, useContext } from 'react';
import { Product, CartItem, Order, User, Category } from '../types';
// Mock Data
export const MOCK_CATEGORIES: Category[] = [{
  id: 'c1',
  name: 'Electronics',
  icon: '💻'
}, {
  id: 'c2',
  name: 'Fashion',
  icon: '👕'
}, {
  id: 'c3',
  name: 'Home',
  icon: '🏠'
}, {
  id: 'c4',
  name: 'Beauty',
  icon: '💄'
}, {
  id: 'c5',
  name: 'Sports',
  icon: '⚽'
}, {
  id: 'c6',
  name: 'Phones',
  icon: '📱'
}, {
  id: 'c7',
  name: 'Books',
  icon: '📚'
}, {
  id: 'c8',
  name: 'Toys',
  icon: '🧸'
}, {
  id: 'c9',
  name: 'Groceries',
  icon: '🛒'
}, {
  id: 'c10',
  name: 'Gaming',
  icon: '🎮'
}, {
  id: 'c11',
  name: 'Health',
  icon: '💊'
}, {
  id: 'c12',
  name: 'Appliances',
  icon: '🔌'
}, {
  id: 'c13',
  name: 'Jewelry',
  icon: '💍'
}, {
  id: 'c14',
  name: 'Automotive',
  icon: '🚗'
}, {
  id: 'c15',
  name: 'Baby',
  icon: '🍼'
}, {
  id: 'c16',
  name: 'Pets',
  icon: '🐾'
}];
export const MOCK_PRODUCTS: Product[] = [{
  id: 'p1',
  categoryId: 'c1',
  name: 'Wireless Bluetooth Earbuds Pro',
  description: 'High-quality noise-canceling wireless earbuds with 24h battery life and deep bass.',
  price: 37500,
  originalPrice: 67500,
  discount: 44,
  rating: 4.8,
  reviews: 1245,
  image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&q=80&w=400', 'https://images.unsplash.com/photo-1484704849700-f032a568e944?auto=format&fit=crop&q=80&w=400'],
  variants: {
    colors: ['#000000', '#FFFFFF']
  },
  seller: {
    name: 'TechStore Official',
    rating: 4.9
  }
}, {
  id: 'p2',
  categoryId: 'c2',
  name: "Men's Casual Sneakers",
  description: 'Comfortable everyday sneakers with breathable mesh and durable rubber sole.',
  price: 26500,
  originalPrice: 37500,
  discount: 30,
  rating: 4.5,
  reviews: 832,
  image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=80&w=400'],
  variants: {
    sizes: ['8', '9', '10', '11', '12'],
    colors: ['#FF0000', '#000000', '#FFFFFF']
  },
  seller: {
    name: 'ShoeMart',
    rating: 4.6
  }
}, {
  id: 'p3',
  categoryId: 'c6',
  name: 'Smart Watch Series 8',
  description: 'Advanced health tracking, fitness metrics, and seamless smartphone integration.',
  price: 149990,
  rating: 4.9,
  reviews: 3021,
  image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&q=80&w=400'],
  variants: {
    colors: ['#000000', '#C0C0C0', '#FFD700']
  },
  seller: {
    name: 'GadgetHub',
    rating: 4.8
  }
}, {
  id: 'p4',
  categoryId: 'c2',
  name: 'Classic Leather Backpack',
  description: 'Vintage style leather backpack perfect for work, school, or travel.',
  price: 41500,
  originalPrice: 56500,
  discount: 26,
  rating: 4.7,
  reviews: 412,
  image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1553062407-98eeb64c6a62?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'LeatherCraft',
    rating: 4.7
  }
}, {
  id: 'p5',
  categoryId: 'c4',
  name: 'Luxury Skincare Set',
  description: 'Complete 5-step skincare routine for glowing, healthy skin.',
  price: 67500,
  rating: 4.6,
  reviews: 560,
  image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1556228578-0d85b1a4d571?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'GlowBeauty',
    rating: 4.9
  }
}, {
  id: 'p6',
  categoryId: 'c1',
  name: 'Ergonomic Gaming Mouse',
  description: 'RGB wireless gaming mouse with ultra-low latency and programmable buttons.',
  price: 22500,
  originalPrice: 37500,
  discount: 40,
  rating: 4.4,
  reviews: 890,
  image: 'https://images.unsplash.com/photo-1563297007-0686b7003af7?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1563297007-0686b7003af7?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'GamerZone',
    rating: 4.5
  }
}, {
  id: 'p7',
  categoryId: 'c3',
  name: 'Minimalist Table Lamp',
  description: 'Modern LED desk lamp with touch dimmer and USB charging port.',
  price: 32500,
  originalPrice: 45000,
  discount: 28,
  rating: 4.6,
  reviews: 318,
  image: 'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'HomeDecor Plus',
    rating: 4.7
  }
}, {
  id: 'p8',
  categoryId: 'c5',
  name: 'Yoga Mat Premium',
  description: 'Extra thick non-slip yoga mat with alignment lines and carrying strap.',
  price: 21500,
  rating: 4.8,
  reviews: 1102,
  image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'FitLife Store',
    rating: 4.8
  }
}, {
  id: 'p9',
  categoryId: 'c10',
  name: 'Wireless Gaming Controller',
  description: 'Dual vibration gamepad with programmable buttons, compatible with PC and console.',
  price: 33500,
  originalPrice: 48500,
  discount: 31,
  rating: 4.5,
  reviews: 723,
  image: 'https://images.unsplash.com/photo-1486401899868-0e435ed85128?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1486401899868-0e435ed85128?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'GamerZone',
    rating: 4.5
  }
}, {
  id: 'p10',
  categoryId: 'c13',
  name: 'Gold Pendant Necklace',
  description: 'Elegant 18K gold-plated pendant necklace with cubic zirconia stones.',
  price: 59990,
  originalPrice: 90000,
  discount: 33,
  rating: 4.7,
  reviews: 245,
  image: 'https://images.unsplash.com/photo-1515562141589-67f0d569b6c4?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1515562141589-67f0d569b6c4?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'LuxeJewels',
    rating: 4.9
  }
}, {
  id: 'p11',
  categoryId: 'c6',
  name: 'Phone Case Ultra Slim',
  description: 'Crystal clear protective case with shock-absorbing corners and anti-yellowing.',
  price: 9750,
  rating: 4.3,
  reviews: 2150,
  image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&q=80&w=400'],
  variants: {
    colors: ['#000000', '#FFFFFF', '#FF69B4']
  },
  seller: {
    name: 'PhoneAccessories',
    rating: 4.4
  }
}, {
  id: 'p12',
  categoryId: 'c12',
  name: 'Air Purifier HEPA',
  description: 'True HEPA air purifier for large rooms, removes 99.97% of allergens.',
  price: 97500,
  originalPrice: 135000,
  discount: 28,
  rating: 4.8,
  reviews: 567,
  image: 'https://images.unsplash.com/photo-1558089687-f282d8b1b0d2?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1558089687-f282d8b1b0d2?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'CleanAir Co',
    rating: 4.8
  }
}, {
  id: 'p13',
  categoryId: 'c11',
  name: 'Vitamin C Supplement',
  description: 'High-potency 1000mg Vitamin C with zinc for immune support, 120 capsules.',
  price: 14250,
  rating: 4.6,
  reviews: 3400,
  image: 'https://images.unsplash.com/photo-1550572017-edd951aa8f72?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1550572017-edd951aa8f72?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'HealthFirst',
    rating: 4.7
  }
}, {
  id: 'p14',
  categoryId: 'c2',
  name: 'Oversized Sunglasses',
  description: 'UV400 polarized oversized sunglasses with gradient lenses and metal frame.',
  price: 18750,
  originalPrice: 30000,
  discount: 38,
  rating: 4.4,
  reviews: 678,
  image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format&fit=crop&q=80&w=400'],
  variants: {
    colors: ['#000000', '#8B4513', '#FFD700']
  },
  seller: {
    name: 'StyleVault',
    rating: 4.5
  }
}, {
  id: 'p15',
  categoryId: 'c8',
  name: 'Building Blocks Set 500pc',
  description: 'Creative building blocks set with 500 pieces, compatible with major brands.',
  price: 24750,
  originalPrice: 33750,
  discount: 27,
  rating: 4.9,
  reviews: 1890,
  image: 'https://images.unsplash.com/photo-1596854407944-bf87f6fdd49e?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1596854407944-bf87f6fdd49e?auto=format&fit=crop&q=80&w=400'],
  seller: {
    name: 'ToyWorld',
    rating: 4.8
  }
}, {
  id: 'p16',
  categoryId: 'c1',
  name: 'Portable Bluetooth Speaker',
  description: 'Waterproof portable speaker with 360° sound and 20-hour battery life.',
  price: 29990,
  rating: 4.7,
  reviews: 2340,
  image: 'https://images.unsplash.com/photo-1545454675-3531b543be5d?auto=format&fit=crop&q=80&w=400',
  images: ['https://images.unsplash.com/photo-1545454675-3531b543be5d?auto=format&fit=crop&q=80&w=400'],
  variants: {
    colors: ['#000000', '#FF0000', '#0000FF']
  },
  seller: {
    name: 'SoundWave',
    rating: 4.6
  }
}];
interface AppContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  cart: CartItem[];
  addToCart: (item: Omit<CartItem, 'id'>) => void;
  removeFromCart: (id: string) => void;
  updateCartQuantity: (id: string, quantity: number) => void;
  cartTotal: number;
  wishlist: string[];
  toggleWishlist: (productId: string) => void;
  orders: Order[];
  placeOrder: (shippingAddress: string) => void;
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  isVendorMode: boolean;
  toggleVendorMode: () => void;
}
const AppContext = createContext<AppContextType | undefined>(undefined);
export function AppProvider({
  children
}: {
  children: ReactNode;
}) {
  const [user, setUser] = useState<User | null>(null);
  const [cart, setCart] = useState<CartItem[]>([]);
  const [wishlist, setWishlist] = useState<string[]>(['p1', 'p3']);
  const [orders, setOrders] = useState<Order[]>([]);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('jummall-dark-mode') === 'true';
    }
    return false;
  });
  const [isVendorMode, setIsVendorMode] = useState(false);
  useEffect(() => {
    const root = document.documentElement;
    if (isDarkMode) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('jummall-dark-mode', String(isDarkMode));
  }, [isDarkMode]);
  const toggleDarkMode = () => setIsDarkMode(prev => !prev);
  const toggleVendorMode = () => setIsVendorMode(prev => !prev);
  const addToCart = (item: Omit<CartItem, 'id'>) => {
    setCart(prev => {
      const existing = prev.find(i => i.product.id === item.product.id && i.selectedColor === item.selectedColor && i.selectedSize === item.selectedSize);
      if (existing) {
        return prev.map(i => i.id === existing.id ? {
          ...i,
          quantity: i.quantity + item.quantity
        } : i);
      }
      return [...prev, {
        ...item,
        id: Math.random().toString(36).substr(2, 9)
      }];
    });
  };
  const removeFromCart = (id: string) => {
    setCart(prev => prev.filter(item => item.id !== id));
  };
  const updateCartQuantity = (id: string, quantity: number) => {
    if (quantity < 1) return;
    setCart(prev => prev.map(item => item.id === id ? {
      ...item,
      quantity
    } : item));
  };
  const cartTotal = cart.reduce((total, item) => total + item.product.price * item.quantity, 0);
  const toggleWishlist = (productId: string) => {
    setWishlist(prev => prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]);
  };
  const placeOrder = (shippingAddress: string) => {
    const newOrder: Order = {
      id: `ORD-${Math.floor(Math.random() * 1000000)}`,
      date: new Date().toISOString(),
      items: [...cart],
      total: cartTotal + 4500,
      status: 'Processing',
      shippingAddress
    };
    setOrders(prev => [newOrder, ...prev]);
    setCart([]); // Clear cart
  };
  return <AppContext.Provider value={{
    user,
    setUser,
    cart,
    addToCart,
    removeFromCart,
    updateCartQuantity,
    cartTotal,
    wishlist,
    toggleWishlist,
    orders,
    placeOrder,
    isDarkMode,
    toggleDarkMode,
    isVendorMode,
    toggleVendorMode
  }} data-id="element-164">
      {children}
    </AppContext.Provider>;
}
export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) throw new Error('useApp must be used within AppProvider');
  return context;
};